export function createHud() {
  const left = document.createElement('div');
  left.className = 'hud hud-left';
  left.textContent = '三体系统 · Trisolaris';

  const right = document.createElement('div');
  right.className = 'hud hud-right';

  const notice = document.createElement('div');
  notice.className = 'hud-notice';
  notice.style.display = 'none';

  document.body.appendChild(left);
  document.body.appendChild(right);
  document.body.appendChild(notice);

  let noticeUntilMs = 0;

  return {
    update({ year, cycleCount, civId, eraLabel }) {
      const parts = ['Year ' + year];
      if (civId != null) parts.push('第 ' + civId + ' 号文明');
      if (eraLabel) parts.push(eraLabel);
      parts.push('Cycle ' + cycleCount);
      right.textContent = parts.join(' · ');
      notice.style.display = performance.now() < noticeUntilMs ? 'block' : 'none';
    },
    showNotice(text, ms = 1800) {
      notice.textContent = text;
      noticeUntilMs = performance.now() + ms;
      notice.style.display = 'block';
    },
  };
}
